import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MapFilters = ({ activeFilters, onFilterChange, onClearFilters }) => {
  const filterCategories = [
    {
      id: 'league',
      label: 'League',
      icon: 'Trophy',
      options: [
        { value: 'all', label: 'All Leagues' },
        { value: 'premier-league', label: 'Premier League' },
        { value: 'la-liga', label: 'La Liga' },
        { value: 'serie-a', label: 'Serie A' },
        { value: 'bundesliga', label: 'Bundesliga' },
        { value: 'ligue-1', label: 'Ligue 1' }
      ]
    },
    {
      id: 'tier',
      label: 'Partnership Tier',
      icon: 'Award',
      options: [
        { value: 'all', label: 'All Tiers' },
        { value: 'platinum', label: 'Platinum' },
        { value: 'gold', label: 'Gold' },
        { value: 'silver', label: 'Silver' }
      ]
    },
    {
      id: 'type',
      label: 'Partnership Type',
      icon: 'Briefcase',
      options: [
        { value: 'all', label: 'All Types' },
        { value: 'club', label: 'Football Clubs' },
        { value: 'academy', label: 'Academies' },
        { value: 'agency', label: 'Agencies' },
        { value: 'media', label: 'Media Partners' }
      ]
    },
    {
      id: 'country',
      label: 'Country',
      icon: 'Globe',
      options: [
        { value: 'all', label: 'All Countries' },
        { value: 'england', label: 'England' },
        { value: 'spain', label: 'Spain' },
        { value: 'italy', label: 'Italy' },
        { value: 'germany', label: 'Germany' },
        { value: 'france', label: 'France' }
      ]
    }
  ];

  const hasActiveFilters = Object.values(activeFilters)?.some(value => value !== 'all');

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 border border-border">
      <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4 mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="Filter" size={20} color="var(--color-primary)" />
          </div>
          <div>
            <h3 className="text-base md:text-lg font-semibold text-foreground font-headline">
              Filter Network
            </h3>
            <p className="text-xs md:text-sm text-muted-foreground">
              Refine your partnership view
            </p>
          </div>
        </div>
        {hasActiveFilters && (
          <Button
            variant="outline"
            size="sm"
            iconName="X"
            iconPosition="left"
            onClick={onClearFilters}
          >
            Clear Filters
          </Button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {filterCategories?.map((category) => (
          <div key={category?.id} className="space-y-2">
            <label className="flex items-center gap-2 text-sm font-medium text-foreground">
              <Icon name={category?.icon} size={16} />
              {category?.label}
            </label>
            <select
              value={activeFilters?.[category?.id]}
              onChange={(e) => onFilterChange(category?.id, e?.target?.value)}
              className="w-full px-3 py-2 bg-background border border-input rounded-md text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-ring transition-all duration-300"
            >
              {category?.options?.map((option) => (
                <option key={option?.value} value={option?.value}>
                  {option?.label}
                </option>
              ))}
            </select>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MapFilters;